import { z } from 'zod';
import { CardContentLiteFieldsSchema, GridLayoutSchema } from '../shared';
import { SanityDocumentSchema, SanityReferenceSchema, SanitySlugSchema } from '../sanity';
import { NewsTagSchema } from './NewsTag';
import { SEOSchema } from '../shared/SEO';
import { EntityType } from '$lib/sanity/types';
import { ImageAssetSchema } from '../components/Image';
import { TextBlockSchema } from '../components/Text';

export const NewsPostPublicationInfoSchema = z.object({
  publicationDate: z.string().optional(),
  author: z.string()
});

const sharedPostSchema = {
  name: z.string(),
  slug: SanitySlugSchema,
  brands: z.array(z.string()).nullish(),
  businessUnit: z.array(z.string()).nullish(),
  format: z.string().nullish(),
  summary: z.string().nullish(),
  tags: z.array(NewsTagSchema.or(SanityReferenceSchema)).nullish().default([]),
  publicationInfo: NewsPostPublicationInfoSchema.nullish(),
  poster: z.lazy(() => ImageAssetSchema.nullish()),
  sortDate: z.string().nullish(),
  seoAttributes: SEOSchema.nullish(),
  cardContent: z.lazy(() => CardContentLiteFieldsSchema.nullish())
};

export const NewsBasicPostSchema = z.lazy(() =>
  SanityDocumentSchema.extend({
    ...sharedPostSchema,
    _type: z.literal(EntityType.NewsBasicPost),
    body: z.lazy(() => z.array(TextBlockSchema).optional())
  })
);

export const NewsPostSchema = z.lazy(() =>
  SanityDocumentSchema.extend({
    ...sharedPostSchema,
    _type: z.literal(EntityType.NewsPost),
    layout: GridLayoutSchema.nullish()
  })
);

export const NewsPostArraySchema = z.array(NewsPostSchema);
export const NewsBasicPostArraySchema = z.array(NewsBasicPostSchema);

export type NewsPostPublicationInfo = z.infer<typeof NewsPostPublicationInfoSchema>;
export type NewsBasicPost = z.infer<typeof NewsBasicPostSchema>;
export type NewsPost = z.infer<typeof NewsPostSchema>;
export type NewsPosts = z.infer<typeof NewsPostArraySchema>;
export type NewsBasicPosts = z.infer<typeof NewsBasicPostArraySchema>;
